import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as CONSTANTS from '../../constants';
import { AdobeAnalyticsDigitalDataService } from 'src/app/service/adobe-analytics-digitaldata.service';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import { EnvironmentConfig } from 'src/environments/environmentConfig';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { Product } from './model';

@Component({
  selector: 'app-your-online-exclusive-rate-offers',
  templateUrl: './your-online-exclusive-rate-offers.component.html',
  styleUrls: ['./your-online-exclusive-rate-offers.component.less'],
  providers: [EnvironmentConfig]
})
export class YourOnlineExclusiveRateOffersComponent implements OnInit {
  isIos: boolean;
  nextPercent: any;
  rateForm: FormGroup;
  displayValidation: boolean = false;
  borderColorY: boolean = false;
  selectedValue = {};
  preQualObj: any;
  modalRef: NgbModalRef;
  lang: string = ''
  fixedRate = [];
  variableRate = [];
  prdDetails: any;
  currLangEn = 'en';
  currLangFr = 'fr';
  prequalType = 'P';
  switchType = 'S';
  quebecProvince = 'QC'
  type = "string"
  res: any;
  currentLang: string;
  clickHere: string;
  date: string;
  formatted: string;
  pdtDetails: any;
  loader: boolean = false;
  closed = { fr: 'fermé', en: 'Closed' };
  flex = { fr: 'FlexiVariable', en: 'Flex' };
  discount = "0%";
  month_en = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  month_fr = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet:", "août:", "septembre", "octobre", "novembre", "décembre"];
  epcData: any;
  bilingualApplicant: boolean = false;
  clickHere_fr: string;
  formatted_fr: string;
  constructor(private _http: HttpClient,
    private modalService: NgbModal,
    private utilService: UtilService,
    private _activatedRoute: ActivatedRoute,
    private i18nService: I18nService,
    private router: Router,
    private translate: TranslateService,
    private adobeAnalyticsData: AdobeAnalyticsDigitalDataService) {
    this.isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    this.utilService.isSidebarVisible.next(true);
    this.utilService.sidebarTitle.next('slideTitles.onlineRate');
    let progressPercent = CONSTANTS.PROGRESS_PERCENTAGE.ONLINE_RATE;
    this.utilService.progressPercent.next(progressPercent);
    this.nextPercent = progressPercent;
    this.utilService.isSidebarVisible.next(true);
    sessionStorage.setItem("progressPercentage", this.nextPercent);
    this.preQualObj = this.utilService.getSessionStorage();
    this.utilService.setSessionStorage(this.preQualObj);
    this.preQualObj = this.utilService.getSessionStorage()



    this.translate.get('online-rate.clickHereLink').subscribe((res: string) => {
      this.clickHere = res || "";
    });

  }
  ngOnInit(): void {
    this.epcData = JSON.parse(sessionStorage.getItem("getProd"));
    this.currentLang = this.i18nService.getCurrentLang();
    this.restructureInputData('F');
    this.restructureInputData('V');
    this.createFrmGrp();
    this.valueChanges();
    this.getDate();
    this.setlangForQuebec();
  }


  getDate() {
    const futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + 5);
    const currentDay = futureDate.getDate();
    const monthIndex = futureDate.getMonth();
    const currentYear = futureDate.getFullYear();
    const currentMonth = (this.currentLang == "en") ? this.month_en[monthIndex] : (this.currentLang == "fr") ? this.month_fr[monthIndex] : '';
    this.formatted = currentMonth + " " + currentDay + ", " + currentYear;
    this.formatted_fr = this.month_fr[monthIndex] + " " + currentDay + ", " + currentYear;
  }
  createFrmGrp() {
    this.rateForm = new FormGroup({
      fixedRate: new FormControl('', Validators.required)
    });
  }
  onContinue() {
    if (this.rateForm.invalid) {
      this.displayValidation = true;
      this.utilService.adobeAnalyticalErrorMsg("product-rates", "missing", "", null);
      const control = this.rateForm.get('fixedRate');
      control.markAsDirty();
      control.markAsTouched();
      document.getElementById('fixedRate').focus();
    }
    else {
      this.loader = true;
      this.displayValidation = false;
      const productDetails = (this.res.products.find(obj => obj.productDetails.rates[0].rate.find(obj => obj.rateValue == this.rateForm.get('fixedRate')?.value.rateValue) && obj.productCode == this.rateForm.get('fixedRate')?.value.prodCode));

      const AmortInd = productDetails.productDetails.rates[0].rate.findIndex((obj => obj.rateValue == this.rateForm.get('fixedRate')?.value.rateValue));
      var AmortRate = this.rateForm.get('fixedRate')?.value.rateValue;
      if (AmortInd == 0) {
        var clientRate = this.rateForm.get('fixedRate')?.value.rateValue;
      }
      else if (AmortInd == 1) {
        clientRate = Number((this.rateForm.get('fixedRate')?.value.rateValue - this.rateForm.get('fixedRate')?.value.arp).toFixed(2));
      }
      sessionStorage.setItem("prdDetails", JSON.stringify(productDetails));
      this.utilService.setSessionStorage(this.preQualObj);
      this.prdDetails = JSON.parse(sessionStorage.getItem("prdDetails"));
      const productBody = {
        "pdtDetails": [{
          "productId": String(this.prdDetails.productDetails.rates[0].rate[0].rateTypeID),
          "clientRate": clientRate,
          "term": this.prdDetails.productDetails.metaData.term.toString(),
          "amortizationStart": 3,
          "amortizationEnd": 30
        }]
      }
      this.preQualObj.productCode = this.prdDetails.productCode;
      this.preQualObj.term = this.prdDetails.productDetails.metaData.term.toString();
      this.preQualObj.rateTypeID = this.rateForm.get('fixedRate')?.value?.rateTypeID.toString();
      this.preQualObj.shortName = (this.currentLang == this.currLangEn) ? this.prdDetails.productDetails.metaData.longName[0].name : (this.currentLang == this.currLangFr) ? this.prdDetails.productDetails.metaData.longName[1].name : '';
      this.initialiseSelectedProduct(clientRate);
      let users = { "users": this.preQualObj };
      const reqBody = { ...users, ...productBody };
      this.dmCall(reqBody, AmortRate, clientRate);
    }
  }
  initialiseSelectedProduct(clientRate: any) {
    if (this.rateForm.get('fixedRate')?.value.discount != null || this.rateForm.get('fixedRate')?.value.discount != undefined) {
      this.discount = this.rateForm.get('fixedRate')?.value?.discount + "%";
    }
    const duration = (this.currentLang == this.currLangEn) ? this.prdDetails.productDetails.metaData.longName[0].name : (this.currentLang == this.currLangFr) ? this.prdDetails.productDetails.metaData.longName[1].name : '';
    if (this.prdDetails.productDetails.rates) {
      this.preQualObj["switch_interest_rate"] = {
        "duration": duration,
        "rate": clientRate + "%",
        "discount": this.discount,
        "arp": this.rateForm.get('fixedRate')?.value?.arp,
        "rateType": (this.prdDetails.productDetails.metaData.rateType) ? this.prdDetails.productDetails.metaData.rateType : ''
      }
    }
  }

  format(rateValue: any) {
    if (this.currentLang == this.currLangEn) {
      return rateValue;
    }
    else if (this.currentLang == this.currLangFr) {
      rateValue = rateValue.toString();
      rateValue = rateValue.replaceAll(".", ",");
      return rateValue;
    }
  }

  valueChanges() {
    this.rateForm.get('fixedRate')?.valueChanges.subscribe(val => {
      this.borderColorY = true;
      this.displayValidation = false;
      this.selectedValue = val;
    })
  }
  AdobeTracking(data) {
    let digitalData = this.adobeAnalyticsData.load(data)

    if (document.getElementById("adobe-tracking-digital-data")) {
      document.getElementById("adobe-tracking-digital-data").remove();
      let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData =" + digitalData + "; if(_satellite){ _satellite.track('track'); }</script>"
      $("head").append(element);
    }
  }

  openTerms(content) {
    this.AdobeTracking('offer-popup?flow=switch');
    this.modalRef = this.modalService.open(content, { backdrop: 'static', centered: true, scrollable: true, animation: true, windowClass: 'custom-width' });
  }
  close() {
    if (this.modalRef) {
      this.modalRef.close();
      this.AdobeTracking('your-online-exclusive-rate-offers?flow=switch')
    }
  }
  restructureInputData(type: string) {
    let getRates = this.getProduct(type);
    if (getRates != null) {
      getRates.forEach((obj, index) => {
        let result: Product = new Product();
        const decimals = (obj.rate_value * 10) % 1 === 0 ? 1 : 2;
        result.productCode = obj.mmtg_product_code;
        result.productDetails.metaData.longName[0].name = obj.mmtg_product_name_eng;
        result.productDetails.metaData.longName[1].name = obj.mmtg_product_name_fr;
        result.productDetails.rates[0].rate[0].rateTypeID = obj.rate_type_id;
        result.productDetails.rates[0].rate[0].rateValue = obj.rate_value;
        result.productDetails.rates[0].rate[1].rateTypeID = obj.rate_type_id;
        result.productDetails.rates[0].rate[1].rateValue = Number((obj.rate_value + Number(obj.arp)).toFixed(decimals));
        result.productDetails.rates[0].rate[1].arp = Number(obj.arp);
        result.productDetails.rates[0].rate[0].arp = Number(obj.arp);
        result.productDetails.rates[0].rate[0].prodCode = obj.mmtg_product_code;
        result.productDetails.rates[0].rate[1].prodCode = obj.mmtg_product_code;
        result.productDetails.metaData.term = obj.term;
        result.productDetails.rates[0].rate[1].discount = obj.discount;
        result.productDetails.rates[0].rate[0].discount = obj.discount;
        result.productDetails.metaData.rateType = obj.mmtg_product_type;
        if (type == CONSTANTS.applicationConstants.fixedRate) {
          this.fixedRate.push(result)
        }
        else if (type == CONSTANTS.applicationConstants.variableRate) {
          result.productDetails.rates[0].rate[0].rateValue = Number((obj.rate_value).toFixed(2));
          result.productDetails.rates[0].rate[1].rateValue = Number((obj.rate_value + Number(obj.arp)).toFixed(decimals));
          this.variableRate.push(result);
        }
        this.res = {
          "products": [...this.fixedRate, ...this.variableRate]
        }
      })
    }
  }
  getProduct(id: string) {
    let rate = this.epcData.filter(obj => obj.mmtg_product_type == id);
    if (rate.length > 0) {
      return rate;
    }
    return null;
  }
  dmCall(reqBody: any, AmortRate: any, clientRate: any) {
    this.utilService.getSwitchDetails(reqBody, 'F').subscribe((res: any) => {
      if (res.txnStatus == CONSTANTS.applicationConstants.cbFailure || !res.pdtDetails || res.userDetails.status.toLowerCase() == CONSTANTS.applicationConstants.declined) {
        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
      else {
        const AmortizationPayments = {
          "selectedAmortization": res.pdtDetails[0].mtgPandIAmtDetails[0].amortization,
          "selectedFrequency": res.pdtDetails[0].mtgPandIAmtDetails[0].paymentDetails[0].paymentFrequency,
          "estimatedPaymentsSwitch": res.pdtDetails[0].mtgPandIAmtDetails[0].paymentDetails[0].prinAndintPaymentAmount
        }
         console.log(res,"res in f call")
        this.preQualObj.amortization_payments = AmortizationPayments;
        
        this.preQualObj['preQualify_mortgage_amount'] = res.preQualifyMortgageAmount;
        this.preQualObj.status = res.userDetails.status;
        this.preQualObj.madvsior = res.userDetails.madvsior;
        sessionStorage.setItem("startTimer for summaryPage", "true");
        this.preQualObj['pdtDetails'] = res.pdtDetails;
        this.preQualObj['prdDetails'] = this.prdDetails;
        this.preQualObj.switch_interest_rate.rate = AmortRate + "%"
        this.utilService.setSessionStorage(this.preQualObj);
        delete this.preQualObj.pdtDetails;
        this.preQualObj.switch_interest_rate.rate = clientRate + "%";
        this.utilService.saveJson(this.preQualObj).subscribe(response => {
          this.loader = false;
          this.preQualObj.created_at = response.created_at;
          this.preQualObj.switch_interest_rate.rate = AmortRate + "%"
          this.utilService.setSessionStorage(this.preQualObj);
        this.router.navigate(['../summary'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });

        }, (err) => {
          this.loader = false;
          this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
        }
        )
      }
    }, (err) => {
      this.loader = false;
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    });
  }
  setlangForQuebec() {
    this.preQualObj.users.forEach((user) => {
      if (user.province == this.quebecProvince && this.currentLang == this.currLangEn) {
        this.bilingualApplicant = true;
      }
    })
    if (this.bilingualApplicant) {
      this.translate.get('online-rate.clickHereLink_fr').subscribe((res: string) => {
        this.clickHere_fr = res || "";
        console.log(this.clickHere_fr, "clickherefrench")
      });
    }
  }
}





